import React , { useCallback,useEffect,useState,useContext } from 'react';
import { Table,Spin,Input,Modal,Button,message,Select,InputNumber,Popover} from 'antd';

import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from '../Projections/Scoring'
import { UserContext } from "../../Contexts/UserContext";
// import { useReactToPrint } from 'react-to-print';
function Admin (props) {
    const { userID } =
    useContext(UserContext);
    
    const [leagues,setLeagues]=useState([])
    const [draftLeagues,setDraftLeagues]=useState([])
    const [draftLeaguesLoading,setDraftLeaguesLoading]=useState([])
    
  
  const getLeagues = async (L)=>{
    console.log("Fetching Leagues")
    await APIrequest(`/api/mfl/allLeagues?`)
    .then(data => {console.log(data);setLeagues(data);
    });
  }

  const getNoDraftPicks = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullNoDraftPicks?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }

  const getIncompleteDraftPicks = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullIncompleteDraftPicks?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }
  const getNotStartedDraftPicks = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullNotStartedDraftPicks?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }

  const getLeagueRules = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullLeagueRules?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }

  const getLeagueSettings = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullLeagueSettings?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }

  const getLeagueTrades = async (L)=>{
    console.log("Fetching Leagues")
    setDraftLeaguesLoading(true)
    await APIrequest(`/api/mfl/pullLeagueTrades?`)
    .then(data => {setDraftLeagues(data);setDraftLeaguesLoading(false);
    });
  }
      

    
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    

    return (
        <div>
           <Button onClick={()=>getLeagues()}>Get Leagues</Button>
           <Button onClick={()=>getIncompleteDraftPicks()}>Get Incomplete Drafts</Button>
           <Button onClick={()=>getNoDraftPicks()}>Get No Drafts</Button>
           <Button onClick={()=>getNotStartedDraftPicks()}>Get Notstarted Drafts</Button>
           <Button onClick={()=>getLeagueRules()}>Get Rules</Button>
           <Button onClick={()=>getLeagueSettings()}>Get Settings</Button>
           <Button onClick={()=>getLeagueTrades()}>Get Trades</Button>
           {JSON.stringify(draftLeagues)}
        </div>
        
        
        )
        
    }

    export default Admin;


